import { render, staticRenderFns } from "./MobileDealBreakdown.vue?vue&type=template&id=d0c4853e&"
import script from "./MobileDealBreakdown.vue?vue&type=script&lang=js&"
export * from "./MobileDealBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./MobileDealBreakdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports